import { tw } from '@/utils/tw';

const Skeleton = tw.theme({
  base: ['h-full', 'w-full', 'animate-pulse', 'bg-gradient-to-r from-gray-100 via-white to-gray-100'],
});

export default Skeleton;
